import { useState, useEffect, useCallback } from 'react';

export function useMobileMenu() {
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = (): void => {
      if (window.innerWidth > 900) setMobileOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleMobile = useCallback((): void => {
    setMobileOpen((prev) => !prev);
  }, []);

  return { mobileOpen, toggleMobile };
}
